module.exports = __webpack_public_path__ + "static/img/USA.2a444a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/banners/USA.png
// module id = 2246
// module chunks = 61